<app-header-hs1 titulo="Indivíduo" (eventSave)="save()" (eventCancel)="voltar()" [deletavel]="deletavel" [editavel]="true"
                (eventDelete)="delete()"/>

<ion-content [fullscreen]="true">
  <ion-list [inset]="true">
    <form #form="ngForm">
      <ion-item>
        <app-gps [(point)]="entidade.ponto" [ligado]="novo"/>
      </ion-item>

      <ion-item>
        <ion-input   labelPlacement="floating" Label="Data/Hora" type="datetime-local" [(ngModel)]="entidade.dataHora" name=data />
      </ion-item>
      <app-taxon-search [grupos]="entidade.metodoAmostragem?.grupos"  [(taxon)]="entidade.taxon"/>
      <ion-item *ngIf="exibir(AtributoEspecime.observacoes)"  >
        <ion-textarea name="obs" [(ngModel)]="entidade.observacoes" labelPlacement="floating" label="Observações"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.dinamicaSocial)">
        <ion-select interface="popover"  name="dinamicaSocial" label-placement="floating" label="Dinâmica Social"
                    [(ngModel)]="entidade.dinamicaSocial">
          <ion-select-option *ngFor="let fu of dinamicas" [value]="fu">{{ fu }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item *ngIf="exibir(AtributoEspecime.individuos)" >
        <ion-input  required max="32000" min="1" [(ngModel)]="entidade.individuos" name="individuos" label-placement="floating"
                   label="Nº de Indivíduos" type="number"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.sexo)">
        <ion-select  interface="popover"  name="sexo" label-placement="floating" label="Sexo"
                    [(ngModel)]="entidade.sexo">
          <ion-select-option *ngFor="let fu of sexos" [value]="fu">{{ fu }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.classeEtaria)">
        <ion-select interface="popover"  name="classeEtaria"clas label-placement="floating" label="Classe Etária"
                    [(ngModel)]="entidade.classeEtaria">
          <ion-select-option *ngFor="let fu of classesEtarias" [value]="fu">{{ fu }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.comportamento)">
        <ion-select   [compareWith]="compareWith" interface="popover"  name="comportamento" label-placement="floating" label="Comportamento"
                    [(ngModel)]="entidade.comportamento">
          <ion-select-option *ngFor="let fu of comportamentos" [value]="fu">{{ fu.nome }}</ion-select-option>
        </ion-select>
      </ion-item>

        <ion-item *ngIf="exibir(AtributoEspecime.formasRegistro)">
          <ion-select interface="popover"  [multiple]="true" name="formaRegistro" label-placement="floating" label="Formas de Registro"
                      [(ngModel)]="entidade.formasRegistro">
            <ion-select-option *ngFor="let fu of formasRegistros" [value]="fu">{{ fu }}</ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item *ngIf="exibir(AtributoEspecime.estado)">
          <ion-select interface="popover" name="estado" label-placement="floating" label="Estado"
                      [(ngModel)]="entidade.estado">
            <ion-select-option *ngFor="let fu of estados" [value]="fu">{{ fu }}</ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item *ngIf="exibir(AtributoEspecime.oleado)">
          <ion-select interface="popover" name="oleado" label-placement="floating" label="Oleado"
                      [(ngModel)]="entidade.oleado">
            <ion-select-option *ngFor="let fu of simNaoAparentemente" [value]="fu">{{ fu }}</ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item *ngIf="exibir(AtributoEspecime.tempo)">
          <ion-select interface="popover"  name="tempo" label-placement="floating" label="Tempo"
                      [(ngModel)]="entidade.tempo">
            <ion-select-option *ngFor="let fu of tempos" [value]="fu">{{ fu }}</ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item  *ngIf="exibir(AtributoEspecime.acionamento)">
          <ion-select interface="popover"  name="acionamento" label-placement="floating" label="Acionamento"
                      [(ngModel)]="entidade.acionamento">
            <ion-select-option *ngFor="let fu of acionamentos" [value]="fu">{{ fu }}</ion-select-option>
          </ion-select>
        </ion-item>

      <ion-item *ngIf="exibir(AtributoEspecime.observadores)">
        <ion-select  interface="popover"  [compareWith]="compareWith" [multiple]="true" name="observadores" label-placement="floating" label="Observadores"
                    [(ngModel)]="entidade.observadores">
          <ion-select-option *ngFor="let fu of observadores" [value]="fu">{{ fu.nome }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.guia)">
        <ion-select  interface="popover"  [compareWith]="compareWith"  name="guia" label-placement="floating" label="Guia"
                    [(ngModel)]="entidade.guia">
          <ion-select-option *ngFor="let fu of guias" [value]="fu">{{ fu.nome }}</ion-select-option>
        </ion-select>
      </ion-item>

      <app-meteorologia *ngIf="exibir(AtributoEspecime.meteorologias)" [entidades]="entidade.meteorologias"/>

      <ion-item  *ngIf="exibir(AtributoEspecime.comprimentoTotal)">
        <ion-input type="number" label-placement="floating" label="Comprimento Total (cm)" inputmode="decimal" min="0"
                   [(ngModel)]="entidade.comprimentoTotal" name="comprimentoTotal" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.comprimentoCauda)">
        <ion-input type="number" label-placement="floating" label="Comprimento Cauda (cm)" inputmode="decimal" min="0"
                   [(ngModel)]="entidade.comprimentoCauda" name="comprimentoCauda" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.comprimentoAsa)">
        <ion-input type="number" label-placement="floating" label="Comprimento da Asa (cm)" inputmode="decimal" min="0"
                   [(ngModel)]="entidade.comprimentoAsa" name="comprimentoAsa" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.comprimentoTarso)">
        <ion-input type="number" label-placement="floating" label="Comprimento do Tarso (cm)" inputmode="decimal" min="0"
                   [(ngModel)]="entidade.comprimentoTarso" name="comprimentoTarso" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.diametroTarso)">
        <ion-input type="number" label-placement="floating" label="Diamêtro do Tarso (cm)" inputmode="decimal" min="0"
                   [(ngModel)]="entidade.diametroTarso" name="diametroTarso" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.pesoCorporal)">
        <ion-input type="number" label-placement="floating" label="Peso Corporal (g)" inputmode="decimal" min="0"
                   [(ngModel)]="entidade.pesoCorporal" name="pesoCorporal" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.comprimentoBico)">
        <ion-input type="number" label-placement="floating" label="Comprimento do Bico (cm)" inputmode="decimal" min="0"
                   [(ngModel)]="entidade.comprimentoBico" name="comprimentoBico" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.larguraBico)">
        <ion-input type="number" label-placement="floating" label="Largura do Bico (cm)" inputmode="decimal" min="0"
                   [(ngModel)]="entidade.larguraBico" name="larguraBico" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.alturaBico)">
        <ion-input type="number" label-placement="floating" label="Altura do Bico (cm)" inputmode="decimal" min="0"
                   [(ngModel)]="entidade.alturaBico" name="alturaBico" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.gorduraSubcutanea)">
        <ion-input type="number" label-placement="floating" label="Gordura Subcutanea (g)" inputmode="decimal" min="0"
                   [(ngModel)]="entidade.gorduraSubcutanea" name="gorduraSubcutanea" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.placaIncubacao)">
        <ion-select name="placaIncubacao" label-placement="floating" label="Placa de Incubação"
                    [(ngModel)]="entidade.placaIncubacao">
          <ion-select-option *ngFor="let fu of simNaoAparentemente" [value]="fu">{{ fu }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.mudaPenas)">
        <ion-select interface="popover"    name="mudaPenas" label-placement="floating" label="Em Muda de Penas"
                    [(ngModel)]="entidade.mudaPenas">
          <ion-select-option *ngFor="let fu of simNaoAparentemente" [value]="fu">{{ fu }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.destino)">
        <ion-select  interface="popover"   name="destino" label-placement="floating" label="Destino"
                    [(ngModel)]="entidade.destino">
          <ion-select-option *ngFor="let fu of destinos" [value]="fu">{{ fu}}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.instituicaoDepositaria)">
        <ion-select interface="popover"  [compareWith]="compareWith"  name="instituicaoDepositaria" label-placement="floating" label="Instituição Depositária"
                    [(ngModel)]="entidade.instituicaoDepositaria">
          <ion-select-option *ngFor="let fu of instituicoes" [value]="fu">{{ fu.nome }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.numeroTombamento)">
        <ion-input label-placement="floating" label="Número de Tombamento"
                   [(ngModel)]="entidade.numeroTombamento" name="numeroTombamento" maxlength="30"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.areaSoltura)">
        <ion-input label-placement="floating" label="Área de Soltura"
                   [(ngModel)]="entidade.areaSoltura" name="areaSoltura" maxlength="30"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.dataHoraSoltura)">
        <ion-input type="datetime-local" label-placement="floating"
                   label="Data/Hora de {{this.ctlExibir.isSoltura ? 'Soltura': 'Envio para Depósito'}}"
                   [(ngModel)]="entidade.dataHoraSoltura" name="dataSoltura" />
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.tipoMarcacao)">
        <ion-select  interface="popover"  [compareWith]="compareWith"  name="tipoMarcacao" label-placement="floating" label="Tipo Marcação"
                    [(ngModel)]="entidade.tipoMarcacao">
          <ion-select-option *ngFor="let fu of tiposMarcacoes" [value]="fu">{{ fu.nome }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.numeroMarcacao)">
        <ion-input label-placement="floating" label="Número de Marcação"
                   [(ngModel)]="entidade.numeroMarcacao" name="numeroMarcacao" maxlength="30"/>
      </ion-item>

<!--      <ion-item  *ngIf="exibir('alturaDossel')">-->
<!--        <ion-input label-placement="floating"  label="Altura Dossel"-->
<!--                   [(ngModel)]="entidade.alturaDossel" name="alturaDossel" maxlength="30"/>-->
<!--      </ion-item>-->

      <ion-item  *ngIf="exibir(AtributoEspecime.temperaturaAr)">
        <ion-input type="number" label-placement="floating"  label="Temperatura do Ar (ºC)" inputmode="decimal"
                   [(ngModel)]="entidade.temperaturaAr" name="temperaturaAr" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.comprimentoRostroCloacal)">
        <ion-input type="number" label-placement="floating" min="0" label="Comprimento Rostro Cloacal (cm)" inputmode="decimal"
                   [(ngModel)]="entidade.comprimentoRostroCloacal" name="comprimentoRostroCloacal" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.comprimentoPadrao)">
        <ion-input type="number" label-placement="floating" min="0" label="Comprimento Padrão (cm)" inputmode="decimal"
                   [(ngModel)]="entidade.comprimentoPadrao" name="comprimentoPadrao" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.estagioMaturacaoGonadal)">
        <ion-select  interface="popover"  name="estagioMaturacaoGonadal" label-placement="floating" label="Estágio Maturação Gonodal"
                    [(ngModel)]="entidade.estagioMaturacaoGonadal">
          <ion-select-option *ngFor="let fu of estagiosMaturacao" [value]="fu">{{ fu }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.comprimentoCorpo)">
        <ion-input type="number" label-placement="floating" min="0" label="Comprimento do Corpo (cm)" inputmode="decimal"
                   [(ngModel)]="entidade.comprimentoCorpo" name="comprimentoCorpo" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.comprimentoPataTraseira)">
        <ion-input type="number" label-placement="floating" min="0" label="Comprimento da Pata Traseira (cm)" inputmode="decimal"
                   [(ngModel)]="entidade.comprimentoPataTraseira" name="comprimentoPataTraseira" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.larguraCabeca)">
        <ion-input type="number" label-placement="floating" min="0" label="Largura da Cabeça (cm)" inputmode="decimal"
                   [(ngModel)]="entidade.larguraCabeca" name="larguraCabeca" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.comprimentoTronco)">
        <ion-input type="number" label-placement="floating" min="0" label="Comprimento do Tronco (cm)" inputmode="decimal"
                   [(ngModel)]="entidade.comprimentoTronco" name="comprimentoTronco" maxlength="6"/>
      </ion-item>
      <ion-item  *ngIf="exibir(AtributoEspecime.alturaCinturaPelvica)">
        <ion-input type="number" label-placement="floating" min="0" label="Altura da Cintura Pélvica (cm)" inputmode="decimal"
                   [(ngModel)]="entidade.alturaCinturaPelvica" name="alturaCinturaPelvica" maxlength="6"/>
      </ion-item>
      <ion-item  *ngIf="exibir(AtributoEspecime.larguraCinturaPelvica)">
        <ion-input type="number" label-placement="floating" min="0" label="Largura da Cintura Pélvica (cm)" inputmode="decimal"
                   [(ngModel)]="entidade.larguraCinturaPelvica" name="larguraCinturaPelvica" maxlength="6"/>
      </ion-item>
      <ion-item  *ngIf="exibir(AtributoEspecime.circunferenciaTorax)">
        <ion-input type="number" label-placement="floating" min="0" label="Circunferência do Torax (cm)" inputmode="decimal"
                   [(ngModel)]="entidade.circunferenciaTorax" name="circunferenciaTorax" maxlength="6"/>
      </ion-item>
      <ion-item  *ngIf="exibir(AtributoEspecime.circunferenciaCabeca)">
        <ion-input type="number" label-placement="floating" min="0" label="Circunferencia da Cabeça (cm)" inputmode="decimal"
                   [(ngModel)]="entidade.circunferenciaCabeca" name="circunferenciaCabeca" maxlength="6"/>
      </ion-item>
      <ion-item  *ngIf="exibir(AtributoEspecime.circunferenciaPescoco)">
        <ion-input type="number" label-placement="floating" min="0" label="Circunferencia do Pescoço (cm)" inputmode="decimal"
                   [(ngModel)]="entidade.circunferenciaPescoco" name="circunferenciaPescoco" maxlength="6"/>
      </ion-item>
      <ion-item  *ngIf="exibir(AtributoEspecime.comprimentoOrelha)">
        <ion-input type="number" label-placement="floating" min="0" label="Comprimento da Orelha (cm)" inputmode="decimal"
                   [(ngModel)]="entidade.comprimentoOrelha" name="comprimentoOrelha" maxlength="6"/>
      </ion-item>
      <ion-item  *ngIf="exibir(AtributoEspecime.distanciaInterOlhos)">
        <ion-input type="number" label-placement="floating" min="0" label="Distância Inter Olhos (cm)" inputmode="decimal"
                   [(ngModel)]="entidade.distanciaInterOlhos" name="distanciaInterOlhos" maxlength="6"/>
      </ion-item>
      <ion-item  *ngIf="exibir(AtributoEspecime.larguraMandibula)">
        <ion-input type="number" label-placement="floating" min="0" label="Largura Mandibula (cm)" inputmode="decimal"
                   [(ngModel)]="entidade.larguraMandibula" name="larguraMandibula" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.prenha)">
        <ion-select  interface="popover"   name="prenha" label-placement="floating" label="Prenha"
                    [(ngModel)]="entidade.prenha">
          <ion-select-option *ngFor="let fu of simNaoAparentemente" [value]="fu">{{ fu }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.lactando)">
        <ion-select  interface="popover" name="lactando" label-placement="floating" label="Lactando"
                    [(ngModel)]="entidade.lactando">
          <ion-select-option *ngFor="let fu of simNaoAparentemente" [value]="fu">{{ fu }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.numeroFilhotes)">
        <ion-input type="number" label-placement="floating" min="0" label="Número de Filhotes" inputmode="decimal"
                   [(ngModel)]="entidade.numeroFilhotes" name="numeroFilhotes" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.glandulasMamarias)">
        <ion-select interface="popover"  name="glandulasMamarias" label-placement="floating" label="Glândulas Mamárias"
                    [(ngModel)]="entidade.glandulasMamarias">
          <ion-select-option *ngFor="let fu of simNaoAparentemente" [value]="fu">{{ fu }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.aberturaVaginal)">
        <ion-select interface="popover"  name="aberturaVaginal" label-placement="floating" label="Abertura Vaginal"
                    [(ngModel)]="entidade.aberturaVaginal">
          <ion-select-option *ngFor="let fu of simNaoAparentemente" [value]="fu">{{ fu }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.escrotado)">
        <ion-select interface="popover"  name="escrotado" label-placement="floating" label="Escrotado"
                    [(ngModel)]="entidade.escrotado">
          <ion-select-option *ngFor="let fu of simNaoAparentemente" [value]="fu">{{ fu }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.comprimentoPe)">
        <ion-input type="number" label-placement="floating" min="0" label="Comprimento do pé (cm)" inputmode="decimal"
                   [(ngModel)]="entidade.comprimentoPe" name="comprimentoPe" maxlength="6"/>
      </ion-item>

      <ion-item  *ngIf="exibir(AtributoEspecime.comprimentoAnteBraco)">
        <ion-input type="number" label-placement="floating" min="0" label="Comprimento do Ante Braço (cm)" inputmode="decimal"
                   [(ngModel)]="entidade.comprimentoAnteBraco" name="comprimentoAnteBraco" maxlength="6"/>
      </ion-item>
      <app-arquivo [(entidades)]="entidade.arquivos"/>

    </form>
  </ion-list>
</ion-content>

<app-rodape [exibirBotoes]="false"/>
